// PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

const PrivateRoute = ({ children }) => {
  const { user, userInfo, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  // If user is not logged in or doesn't have a verified role, redirect to login
  if (!loading && (!user || !userInfo)) return <Navigate to="/login" />;

  return children;
};

export default PrivateRoute;
